import ApiService from "../../../utils/api.service";
export default {
    orderConfirmation(context, params){
        return new Promise((resolve, reject) => {
            ApiService.put("v1/scheduler/reservation/"+params.orderId+"/confirmation", params)
            .then(({ data }) => {      
                context.commit("scheduler/set_reservation", data.reservations,{root:true})
                resolve(data);
            })
            .catch(() => {
                reject();
            })
        })
    },
    billingAddress(context, params){
        return new Promise((resolve, reject) => {
            ApiService.put("v1/scheduler/reservation/"+params.orderId+"/billing-address", params)
            .then(({ data }) => {      
                resolve(data);
            })
            .catch((data) => {
                reject(data);
            })
        })
    }
}